import { APP_SETTING_KEYS, type AppSettingKey } from '@/config/app-setting.config'
import { APP_ID } from '@/config/constants.config'
import { PREFILL_KEYS, type PrefillKey } from '@/config/prefill.config.ts'

export const useDataAttributes = () => {
  const mountElement = document.getElementById(APP_ID)

  const getParams = <Key extends PrefillKey | AppSettingKey>(keys: readonly Key[]) =>
    keys.reduce(
      (result, key: Key) => {
        result[key] = mountElement?.getAttribute(`data-${key.replace(/_/g, '-')}`) ?? null
        return result
      },
      {} as Record<Key, string | null>
    )

  const appSettingParams = getParams(APP_SETTING_KEYS)

  return {
    variant: appSettingParams.variant,
    //variant: 'mini', // Quickest way for testing the mini variant
    showAdLabel: appSettingParams.show_ad_label,
    partnerId: appSettingParams.partner_id,
    integrationId: appSettingParams.integration_id,
    appSettingParams,
    prefillParams: getParams(PREFILL_KEYS)
  }
}
